import { color as foundationColor } from "../tokens/foundation";
import { color as semanticColor } from "../tokens/semantic";

const { primary, secondary, error, warning, info, success, neutral, tertiary, yellow, darkGreen, teal } = foundationColor;
const { text, border, bg } = semanticColor;

const onDark = neutral.white;
const onLight = neutral.black;

export const palette = {
    mode: 'light',
    primary: {
        main: primary[600],
        light: primary[400],
        dark: primary[800],
        contrastText: onDark,
        ...primary,
    },
    secondary: {
        main: secondary[600],
        light: secondary[400],
        dark: secondary[800],
        contrastText: onDark,
        ...secondary,
    },
    error: {
        main: error[600],
        light: error[400],
        dark: error[800],
        contrastText: onDark,
        ...error,
    },
    warning: {
        main: warning[600],
        light: warning[400],
        dark: warning[800],
        contrastText: onDark,
        ...warning,
    },
    info: {
        main: info[600],
        light: info[400],
        dark: info[800],
        contrastText: onDark,
        ...info,
    },
    success: {
        main: success[600],
        light: success[400],
        dark: success[800],
        contrastText: onDark,
        ...success,
    },
    grey: {
        50: neutral[50],
        100: neutral[100],
        200: neutral[200],
        300: neutral[300],
        400: neutral[400],
        500: neutral[500],
        600: neutral[600],
        700: neutral[700],
        800: neutral[800],
        900: neutral[900],
        A100: neutral.white50,
        A700: neutral.black50,
    },
    common: {
        black: neutral.black,
        white: neutral.white,
    },
    tertiary: {
        main: tertiary[600],
        light: tertiary[400],
        dark: tertiary[800],
        contrastText: onDark,
        ...tertiary,
    },
    yellow: {
        main: yellow[600],
        light: yellow[400],
        dark: yellow[800],
        contrastText: onDark,
        ...yellow,
    },
    darkGreen: {
        main: darkGreen[600],
        light: darkGreen[400],
        dark: darkGreen[800],
        contrastText: onDark,
        ...darkGreen,
    },
    teal: {
        main: teal[600],
        light: teal[400],
        dark: teal[800],
        contrastText: onDark,
        ...teal,
    },
    text: {
        primary: text.body,       // default text color
        secondary: text.muted,    // secondary text color for subdued text, use for field labels and form descriptors
        disabled: text.disabled,  // disabled field values or inactive items and labels
    },
    background: {
        default: bg.primary,      // overall app background for the body element
        paper: bg.surface,        // surfaces of components like cards, modals, dropdowns, etc.
    },
    nav: {
        main: bg.navMain,               // main navigation background (drawer, header)
        sub: bg.navSub,                 // sub navigation background (sub-menus)
        subText: text.navLight,         // text color for nav items on light backgrounds
        subIcon: neutral[700],             // icon color for nav items
        inactiveHover: primary[900],    // hover state for nav items
        activeHover: primary[500],      // hover state for active nav items
    },
    // divider: border.default.light,
};

export default palette;